import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import moment from "moment";
import "moment/locale/es";

import App from "./App";
// import Pending from "./components/views/goback/Pending";
import Page404 from "./components/views/goback/Page404";
import ScrollToTop from "./components/layout/ScrollToTop";
import Stats from "./components/views/dashboard/Stats";
import Verifications from "./components/views/verifications/Verifications";
import Usuarios from "./components/views/usuarios/Usuarios";
import Verificadores from "./components/views/verificadores/Verificadores";
import Clients from "./components/views/clients/Clients";
import VerifiedPlaces from "./components/views/verified_places/VerifiedPlaces";
import Persons from "./components/views/persons/Persons";
import CalendarView from "./components/views/calendar/CalendarView";
import VerificationPreview from "./components/views/verifications/VerificationPreview";
import Mods from "./components/views/mods/ModsList";
import Cotizaciones from "./components/views/cotizaciones/CotizacionesList";
import Avances from "./components/views/avances/Avances";
import Perfil from "./components/layout/Perfil";
import Notificaciones from "./components/views/notificaciones/Notificaciones";
import Pagos from "./components/views/pagos/Pagos";
import PagosPorVerificacion from "./components/views/pagos/PagosPorVerificacion";
import PagosIndex from "./components/views/pagos/PagosIndex";
import ListOfPagosByVerification from "./components/views/pagos/ListOfPagosByVerification";
import Reportes from "./components/views/reportes/Reportes";
import { AuthProvider } from "./components/layout/auth";

moment.updateLocale("es", {
  months: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <React.StrictMode>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<Stats />} />
            <Route path="verificaciones" element={<Verifications />} />
            <Route path="verificaciones/:id" element={<VerificationPreview />} />
            <Route path="notificaciones" element={<Notificaciones />} />
            <Route path="calendario" element={<CalendarView />} />
            <Route path="cotizaciones" element={<Cotizaciones />} />
            <Route path="clientes" element={<Clients />} />
            <Route path="razonessociales" element={<VerifiedPlaces />} />
            <Route path="personas" element={<Persons />} />
            <Route path="mods" element={<Mods />} />
            <Route path="perfil" element={<Perfil />} />
            <Route path="avances" element={<Avances />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="verificadores" element={<Verificadores />} />
            <Route path="reportes" element={<Reportes />} />
            <Route path="pagos">
              <Route index element={<Pagos />} />
              <Route path="por-verificacion" element={<PagosPorVerificacion />} />
              <Route path=":verificacionId" element={<ListOfPagosByVerification />} />
            </Route>
            <Route path="*" element={<Page404 />} />
          </Route>
          <Route path="*" element={<Page404 />} />
        </Routes>
      </Router>
    </React.StrictMode>
  </AuthProvider>
);
